import { chakra, Button as CkButton, Text } from '@chakra-ui/react'
import { DARK_TEXT_MUTED } from 'constants/dark-tokens'

export const TextTitle = chakra(Text, {
  baseStyle: () => ({
    minWidth: '168px',
    color: DARK_TEXT_MUTED,
    fontSize: 'sm',
    fontWeight: 600,
    lineHeight: 6,
    margin: 0
  })
})

export const Button = chakra(CkButton, {
  baseStyle: () => ({
    minWidth: 0,
    width: 6,
    height: 6,
    padding: 0,
    boxShadow: 'unset',
    border: 'unset',
    background: 'transparent',
    color: DARK_TEXT_MUTED,
    _hover: { background: 'rgba(255,255,255,0.08)' },
    _focus: { borderColor: 'unset' },
    _active: { borderColor: 'unset' }
  })
})
